export default {
    confirm: '保存',
    documentTypes: {
        acceptance: '検収書',
        deliveryslip: '納品書',
        invoice: '請求書',
        order: '発注書（取引先宛）', // Different for ConversionSettings
        orderconfirmation: '注文請書',
        orderslip: '発注書（自社宛）', // Different for ConversionSettings
        quote: '見積書',
        receipt: '領収書',
        timesheet: '作業報告書',
    },
    helpText: '{{type}}へ変換する際は、各項目の設定方法を選んでください。',
    messagesLabel: '備考',
    notesLabel: 'メモ',
    options: {
        copyFromPreset: '書類定型パターンの内容を適用',
        copyFromSource: '変換元書類の内容をコピー',
        leaveBlank: '空欄',
    },
    title: '書類の変換設定',
};
